import { render, staticRenderFns } from "./ScreenSize.vue?vue&type=template&id=44928ab7&scoped=true"
import script from "./ScreenSize.vue?vue&type=script&lang=js"
export * from "./ScreenSize.vue?vue&type=script&lang=js"
import style0 from "./ScreenSize.vue?vue&type=style&index=0&id=44928ab7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44928ab7",
  null
  
)

export default component.exports